if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        // this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        
        // Preserve original thumbnail order on mobile after page load
        this.preserveMobileThumbnailOrder();
        
        // Scroll to selected thumbnail on both mobile and desktop if not visible
        this.scrollToSelectedThumbnailOnLoad();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        // this.setActiveThumbnail(thumbnail);
        console.log("thumbnail: ", thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          // if (this.elements.thumbnails) {
          //   const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          //   activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          // }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          
          // Only scroll to media on desktop (not mobile)
          if (this.mql.matches) {
            const activeMediaRect = activeMedia.getBoundingClientRect();
            // Don't scroll if the image is already in view
            if (activeMediaRect.top > -0.5) return;
            const top = activeMediaRect.top + window.scrollY;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        
        // Only scroll to thumbnail if it's not visible, but don't change its position in the slider
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        // Scroll to make the thumbnail visible without changing its position
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      preserveMobileThumbnailOrder() {
        // Only run on mobile
        if (this.mql.matches) return;
        
        const thumbnailList = this.elements.thumbnails.querySelector('ul');
        if (!thumbnailList) return;
        
        // Get all thumbnail items
        const thumbnailItems = Array.from(thumbnailList.querySelectorAll('li[data-target]'));
        if (thumbnailItems.length <= 1) return;
        
        // Find the currently selected thumbnail (the one with aria-current="true")
        const selectedThumbnail = thumbnailItems.find(item => 
          item.querySelector('button[aria-current="true"]')
        );
        
        if (!selectedThumbnail) return;
        
        // If the selected thumbnail is the first one, we need to reorder
        // The first thumbnail should be the first product media, not the selected variant
        if (thumbnailItems[0] === selectedThumbnail) {
          // Get all thumbnails except the selected one
          const otherThumbnails = thumbnailItems.filter(item => item !== selectedThumbnail);
          
          if (otherThumbnails.length > 0) {
            // Sort thumbnails by their media position to restore original order
            const allThumbnails = [selectedThumbnail, ...otherThumbnails];
            allThumbnails.sort((a, b) => {
              const posA = parseInt(a.dataset.mediaPosition) || 1;
              const posB = parseInt(b.dataset.mediaPosition) || 1;
              return posA - posB;
            });
            
            // Clear the thumbnail list and re-add in correct order
            thumbnailList.innerHTML = '';
            allThumbnails.forEach(thumbnail => {
              thumbnailList.appendChild(thumbnail);
            });
          }
        }
        
        // Scroll to the selected thumbnail if it's not visible
        this.scrollToSelectedThumbnail(selectedThumbnail);
      }
      
      scrollToSelectedThumbnail(selectedThumbnail) {
        if (!selectedThumbnail || !this.elements.thumbnails) return;
        
        // Check if the selected thumbnail is visible in the slider
        if (!this.elements.thumbnails.isSlideVisible(selectedThumbnail, 10)) {
          // Scroll to the selected thumbnail
          this.elements.thumbnails.slider.scrollTo({ 
            left: selectedThumbnail.offsetLeft,
            behavior: 'smooth'
          });
        }
      }
      
      // Add method to scroll to selected thumbnail on both mobile and desktop
      scrollToSelectedThumbnailOnLoad() {
        if (!this.elements.thumbnails) return;
        
        // Find the currently selected thumbnail
        const selectedThumbnail = this.elements.thumbnails.querySelector('li[data-target] button[aria-current="true"]')?.closest('li');
        
        if (selectedThumbnail) {
          this.scrollToSelectedThumbnail(selectedThumbnail);
        }
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}